import { useEffect } from "react";
import upperFirst from "lodash/upperFirst";

import { useCurrentToolId, useCurrentProductId } from "@adsk/alloy-provider";
import { useRemote } from "@adsk/exo-skeleton-react";

interface ExoPerformanceTrackingProps {
  displayName: string;
  loading: boolean;
}

const reportedNames = new Set();

export const useExoPerformanceTracking = ({
  displayName: name,
  loading,
}: ExoPerformanceTrackingProps) => {
  // For local development if you are not using EXO framework:
  // The useRemote won't be available. Added a protection here and also check it inside effect.
  const { trackReady } = useRemote() || {};
  const toolId = useCurrentToolId();
  const productId = useCurrentProductId();

  useEffect(() => {
    if (reportedNames.has(name)) {
      return;
    }
    if (!!trackReady && !loading && name) {
      const displayName = `${upperFirst(productId)} ${upperFirst(
        toolId
      )} - ${name}`;
      trackReady({ metadata: { displayName } });
      reportedNames.add(name);
    }
  }, [loading, name, productId, toolId, trackReady]);

  return null;
};
